var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuidao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE4\xB8\xAD\xE9\x9A\xA7\xE9\x81\x93 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8275 7.25009H10.8275L10.8274 7.24197C10.8153 6.50005 10.5122 5.79259 9.98322 5.27218C9.45429 4.75177 8.74199 4.46011 7.99997 4.46011C7.25795 4.46011 6.54566 4.75177 6.01673 5.27218C5.48779 5.79259 5.1846 6.50005 5.17255 7.24197L5.17248 7.24197V7.25009V11.3228L2.99139 15.3196H1.51196V7.1487C1.51196 3.57242 4.41232 0.672058 7.9886 0.672058H8.01134C11.5876 0.672058 14.488 3.57242 14.488 7.1487V15.3196H13.0086L10.8275 11.3228V7.25009ZM6.71468 12.1734H9.24266L10.9443 15.3241L5.03109 15.2997L6.71468 12.1734Z",
    fill: "#626262",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuidao);
export default __webpack_public_path__ + "static/media/suidao.d5c471a1ed409c14d20f1b45e71fc809.svg";
export { ForwardRef as ReactComponent };